import { makeStyles } from "@material-ui/core";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectFormData } from "../../../store/slicers/address";
import { selectPreOrderList } from "../../../store/slicers/preorder";
import {
  getGiftCards,
  selectGiftCards,
  selectTextTemplates,
} from "../../../store/slicers/template";
import { ISelectedTemplate } from "../../models/Interfaces/template.interface";

const useStyles = makeStyles((theme: any) => ({
  container: {
    width: "470px",
    maxWidth: "100%",
  },
  w100: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  letter: {
    height: "665px",
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    justifyContent: "center",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
    margin: "0 auto",
    zIndex: 1,
    background: "#FFFFFF",
    position: "relative",
    [theme.breakpoints.down("575")]: {
      "& div": {
        fontSize: 14,
      },
    },
  },
  envelope: {
    width: "322px",
    maxWidth: "100%",
    height: "160px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
    margin: "-30px auto 0",
    zIndex: 2,
    background: "#FFFFFF",
    position: "relative",
    [theme.breakpoints.down("430")]: {
      width: 260,
    },
  },
  postCard: {
    width: "267px",
    maxWidth: "100%",
    height: "133px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
    margin: "-30px auto 0",
    zIndex: 3,
    background: "#FFFFFF",
    position: "relative",
    [theme.breakpoints.down("430")]: {
      width: 240,
    },
  },
  giftCard: {
    width: "195px",
    maxWidth: "100%",
    height: "135px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
    margin: "-30px auto 0",
    zIndex: 4,
    background: "#FFFFFF",
    position: "relative",
    [theme.breakpoints.down("430")]: {
      width: 170,
    },
  },
  textArea: {
    position: "absolute",
    left: "10%",
    top: "40%",
    width: "80%",
    margin: "0 auto",
    fontSize: 9,
    [theme.breakpoints.down("767")]: {
      fontSize: 8,
      top: "41%",
    },
    [theme.breakpoints.down("575")]: {
      fontSize: 6,
      top: "43%",
    },
    [theme.breakpoints.down("430")]: {
      top: "44%",
      fontSize: 5,
    },
  },
  headerText: {
    marginBottom: 8,
    position: "absolute",
    top: "-145px",
    left: "0",
    width: "90px",
    fontSize: "9px",
    wordBreak: "break-word",
    [theme.breakpoints.down("575")]: {
      fontSize: "7px",
    },
  },
  name: {
    marginBottom: 10,
    fontStyle: "italic",
  },
  description: {
    height: "157px",
    maxWidth: "100%",
    overflow: "hidden",
    marginBottom: "25px",
    fontStyle: "italic",
    textDecoration: "none",
    whiteSpace: "normal",
    display: "-webkit-box",
    lineClamp: 12,
    boxOrient: "vertical",
    wordBreak: "break-word",
    [theme.breakpoints.down("575")]: {
      height: "90px",
    },
  },
  endText: {
    marginTop: 10,
    textAlign: "right",
    marginRight: "10px",
  },
}));

const SelectedTemplates = ({
  pathname,
  textName,
  textValue,
  endText,
}: ISelectedTemplate) => {
  const styles = useStyles();
  const giftCards = useSelector(selectGiftCards);
  const textTemplates = useSelector(selectTextTemplates);
  const receiverData = useSelector(selectFormData);
  const preOrderList = useSelector(selectPreOrderList);
  const dispatch = useDispatch();

  const selectedItemsData: any = useMemo(() => {
    if (preOrderList?.length) {
      if (Array.isArray(preOrderList)) {
        const giftCardsData = preOrderList.find(
          (item) => item.route === "/addresses"
        );
        if (giftCardsData) {
          const parsedData = giftCardsData?.json.replace(/¶œÆ/g, '"');
          const parsedGiftCardsData = JSON.parse(parsedData)
            .selectedGiftCardIDs;
          const giftCardId = Object.keys(parsedGiftCardsData)?.[0];
          const giftCard = giftCards?.find(
            (item: any) => Number(item?.companyID) === Number(giftCardId)
          );
          const template = textTemplates?.find(
            (item: any) => item?.active === true
          );
          return {
            giftCard,
            template,
            receiverData,
          };
        }
      }
    }
  }, [giftCards, textTemplates, receiverData, preOrderList]);

  useEffect(() => {
    Promise.all([dispatch(getGiftCards())]);
  }, [dispatch]);

  return (
    <Grid className={`${styles.container} container-responsive`}>
      <Box className={styles.letter}>
        <Box>
          Սիրելի ___________{" "}
          <span style={{ fontStyle: "italic" }}>(ստացողի անունը)</span>
        </Box>
        <br />
        <Box>
          Ամանորի կապակցությամբ ______________{" "}
          <span style={{ fontStyle: "italic" }}>(ուղարկողի անունը)</span> Ձեզ
          համար յուրահատուկ անակնկալ է պատրաստել։ Նա նվիրաբերել է գումար
          Հայաստանի երեխաների առողջության հիմնադրամին՝ աջակցելով առողջական
          խնդիրներ ունեցող արցախցի երեխաներին ստանալ կենսական նշանակության
          դեղորայք և նրանց պարգևելով ամանորյա բերկրանք։
        </Box>
        <br />
        <Box>
          Սրտացավ ու հոգատար մարդկանց նվիրատվությունների շնորհիվ երեխաները
          կարողանում են ստանալ անհրաժեշտ բուժում և վայելել իրենց առողջ
          մանկությունը։
        </Box>
        <br />
        <Box>
          Թող այս բացառիկ նվերը ձեր սիրտը լցնի ջերմությամբ. համոզված եղեք, որ
          Ձեզ մատուցված նվերը երեխաների կյանքեր է փոխելու։
        </Box>
        <br />
        <Box>
          Դուք նույնպես կարող եք միանալ մեր արշավին և դառնալ բարության շղթայի մի
          մասնիկը՝ սքանավորելով հետևյալ QR կոդը։
        </Box>
      </Box>
      <Box className={styles.envelope}>
        <img
          src={`https://namak.haypost.am/${selectedItemsData?.giftCard?.mediaPath}?v=3`}
          className={styles.w100}
          alt="giftCard"
        />
      </Box>
    </Grid>
  );
};

export default SelectedTemplates;
